import React, { useState } from 'react'
import { Layout } from 'layouts/default'
import s from '../home/home.module.scss'
import dynamic from 'next/dynamic'

import NeonPieChart from '../../components/NeonPieChart'
import MagicBento from 'components/MagicBento/MagicBento.jsx'
import { AppearTitle } from '../../components/appear-title'

export default function TimelinePage() {

  const [theme] = useState('light')

  const WebGL = dynamic(
    () => import('components/webgl').then(({ WebGL }) => WebGL),
    { ssr: false }
  )

  return (
    <Layout
      theme={theme}
      seo={{
        title: 'Xeno Robotics',
        description:
          'Xeno Robotics is a pioneering engineering firm fusing state-of-the-art robotics with blockchain-driven intelligence to deliver autonomous systems that adapt, learn, and collaborate in diverse environments.',
      }}
      className={s.home}
    >
      <div className={s.canvas}>
        <WebGL />
      </div>

      <div style={{ height: '10vh' }}></div>

      <p
        className="h2"
        style={{ color: '#000', textAlign: 'center', marginBottom: '20px' }}
      >
        <AppearTitle>TOKENOMICS</AppearTitle>
      </p>

      <div style={{ height: '10vh' }}></div>

      <MagicBento />

      <div style={{ height: '10vh' }}></div>

      <NeonPieChart />

    </Layout>
  )
}
